import { CreamColor } from "./CreamColor.js";

export const creamColorMap: Record<CreamColor, string> = {
	[CreamColor.Blue]: "bg-[#B5E9F9] text-black",
	[CreamColor.Green]: "bg-[#B7F7B5] text-black",
	[CreamColor.White]: "bg-[#FFFDF2] text-black",
	[CreamColor.Red]: "bg-[#FA797D] text-black",
	[CreamColor.Pink]: "bg-[#FFCAED] text-black",
	[CreamColor.Purple]: "bg-[#CDABEB] text-black",
	[CreamColor.Gray]: "bg-[#ECEAEE] text-black",
	[CreamColor.Yellow]: "bg-[#FFF9C1] text-black",
};
